import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.INIT = (state, payload) => {
  state.excelRows = payload.excelRows
  state.surveyRows = payload.surveyRows
  state.purchaseRows = payload.purchaseRows
}

const state = {
  excelRows: [],
  surveyRows: [],
  purchaseRows: []
}

const actions = {
  init: ({ commit }) => {
    const ctx = {
      data: {
        init: { api: 'C0002CustomersService.init' }
      }
    }
    return client.postData(ctx)
      .then((data) => {
        const output = data.init.output
        commit('INIT', output)
      })
  }
}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module
